import { RX_MODEL_TYPES, TX_MODEL_TYPES } from "../../LibraryHelper";
import { parseIBISModelSelector } from "../../LibraryHelper/IBISModelHelper";

class IBISModelHelper {
  constructor(ids = []) {
    for (const id of ids) {
      this[id] = null;
    }
  }

  getIbisFiles() {
    return Object.keys(this);
  }

  deleteModel(id) {
    delete this[id];
  }

  parseModelSelector(id, fileContent) {
    this[id] = parseIBISModelSelector(fileContent);
  }

  /*get model list by filename*/
  getIbisModelList(id, type) {
    const models = this[id];
    const modelTypes = type === 'Tx' ? TX_MODEL_TYPES :
      type === 'Rx' ? RX_MODEL_TYPES : null;
    if (modelTypes === null || !models) {
      return models;
    } else {
      return { models: models.models.filter(model => modelTypes.includes(model.type)), selectorModels: models.selectorModels, packages: models.packages }
    }
  }
}

export default IBISModelHelper;